import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SubProfessionalCategoryRoutingModule } from './sub-professional-category-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SubProfessionalCategoryRoutingModule
  ]
})
export class SubProfessionalCategoryModule { }
